import { render, staticRenderFns } from "./MatchPotentialOccupationsTable.vue?vue&type=template&id=987e06b6&scoped=true&"
import script from "./MatchPotentialOccupationsTable.vue?vue&type=script&lang=js&"
export * from "./MatchPotentialOccupationsTable.vue?vue&type=script&lang=js&"
import style0 from "./MatchPotentialOccupationsTable.vue?vue&type=style&index=0&id=987e06b6&lang=scss&scoped=true&"
import style1 from "./MatchPotentialOccupationsTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987e06b6",
  null
  
)

export default component.exports